import styled from "styled-components";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, calcRemFontSize } from "@similarweb/styles";

import { ButtonStyled, IconButtonStyled } from "app/components/React/TrialHook/TrialHook.styled";
import { i18nFilter } from "app/filters/i18nFilter";

interface ITrialHookProps {
    text: string;
    buttonText: string;
    label: string;
    iconName?: IconName;
    ctaIconName?: IconName;
    onCtaClick?: () => void;
}

type TrialHookLayoutType = "row" | "column";

interface ITrialHookElementProps {
    layout: TrialHookLayoutType;
}

const TrialHookContent = styled.div<ITrialHookElementProps>`
    display: flex;
    flex-direction: ${({ layout }) => layout};
    align-items: center;
    padding: 12px 30px 12px 20px;
    background-color: ${colorsPalettes.sky[100]};
`;

const TrialHookIconWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    margin-right: 16px;
    background-color: ${colorsPalettes.indigo[400]};
    border-radius: 50%;
    path {
        fill: ${colorsPalettes.carbon[0]};
    }
`;

const TrialHookText = styled.p<ITrialHookElementProps>`
    margin: ${({ layout }) => (layout === "row" ? "0 auto 0 0" : "0 0 10px")};
    ${({ layout }) => (layout === "row" ? calcRemFontSize(16) : calcRemFontSize(14))};
    color: ${colorsPalettes.indigo[300]};
    line-height: normal;
`;

const TrialHook = (props: ITrialHookProps) => {
    const { text, buttonText, iconName, onCtaClick, ctaIconName } = props;
    const layout: TrialHookLayoutType = iconName ? "row" : "column";

    return (
        <TrialHookContent layout={layout}>
            {iconName ? (
                <TrialHookIconWrap>
                    <SWReactIcons
                        iconName={iconName}
                        size="sm"
                    />
                </TrialHookIconWrap>
            ) : null}
            <TrialHookText
                layout={layout}
                dangerouslySetInnerHTML={{
                    __html: i18nFilter()(text),
                }}
            />
            {ctaIconName ? (
                <IconButtonStyled
                    type="trial"
                    iconName={ctaIconName}
                    onClick={onCtaClick}
                    data-automation="trial-hook-cta-button"
                >
                    {i18nFilter()(buttonText)}
                </IconButtonStyled>
            ) : (
                <ButtonStyled
                    type="trial"
                    onClick={onCtaClick}
                    data-automation="trial-hook-cta-button"
                >
                    {i18nFilter()(buttonText)}
                </ButtonStyled>
            )}
        </TrialHookContent>
    );
};

TrialHook.displayName = "TrialHook";

export default TrialHook;
